/* global Date, Math */
import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import Modal from "react-bootstrap/Modal";
import {
    Col,
    Container,
    Dropdown,
    Form,
    Spinner,
    Image,
    ProgressBar,
    Button,
    Card,
    InputGroup,
    ButtonGroup
} from "react-bootstrap";
import { Context } from "../../index";
import { observer } from "mobx-react-lite";
import {
    createBook,
    fetchCurrentUserBooks,
    getFullBookDataUrlApi, getFullProductDataUrlApi, // 🔹 добавлено: API-граббер
} from "../../http/bookAPI";
import Row from "react-bootstrap/Row";
import AvatarEditor from 'react-avatar-editor';
import defaultImage from "../../assets/empty-cover.jpg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getRedirectUrlApi } from "../../http/userAPI";
import CacheUpdateModalBook from "../../helpers/CacheUpdateModalBook";

const AddProductByGrabFromAmazon = observer(({ }) => {
    const { book } = useContext(Context);
    const { user } = useContext(Context);

    const [titleState, setTitleState] = useState('');
    const [subtitleState, setSubTitleState] = useState('');
    const [authorState, setAuthorState] = useState('');
    const [summaryState, setSummaryState] = useState('');
    const [originalCover, setOriginalCover] = useState(null);
    const [coverFileState, setCoverFileState] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [coverPreview, setCoverPreview] = useState(defaultImage);
    const [amzlinkState, setAmzlinkState] = useState(''); // 🔹 будет использовано на шаге 0
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [showEditor, setShowEditor] = useState(false);
    const [scale, setScale] = useState(1);
    const [editorRef, setEditorRef] = useState(null);
    const [editorSize, setEditorSize] = useState({ width: 240, height: 360 });
    const [bookFormat, setBookFormat] = useState("6x9");
    const [description, setDescription] = useState("");

    const [kindlePriceState, setKindlePriceState] = useState('');
    const [paperbackPriceState, setPaperbackPriceState] = useState('');
    const [hardcoverPriceState, setHardcoverPriceState] = useState('');
    const [fourthPriceState, setFourthPriceState] = useState('');

    const [noManuscript, setNoManuscript] = useState(true);
    const [publicCatalogVisible, setPublicCatalogVisible] = useState(true);

    const [paperbackAsinState, setPaperBackAsinState] = useState('');
    const [kindleAsinState, setKindleAsinState] = useState('');
    const [hardcoverAsinState, setHardCoverAsinState] = useState('');
    const [audioAsinState, setAudioAsinState] = useState('');
    const [audibleAsinState, setAudibleAsinState] = useState('');
    const [audioBookLinkState, setAudioBookLinkState] = useState('');
    const [selectedWordCount, setSelectedWordCount] = useState({
        id: 1, count: 10000, label: "About 10,000"
    });

    const parentRef = useRef(null);

    const [newBook, setNewdBook] = useState({
        message_flag: false,
        paper_back_flag: false,
        kindle_flag: true,
        kindle_unlimited_flag: false,
        hard_cover_flag: false,
        audio_flag: false,
        audio_exclusive_flag: false,
        audio_non_exclusive_flag: false,
        cover_file: null,
        summary: null,
        description_full: null,
        book_file: null,
        bp_asin: null,
        k_asin: null,
        hc_asin: null,
        audio_asin: null,
        book_temp_file: null,
    });

    const [step, setStep] = useState(0); // 0 — новый шаг: только поле с линком
    const [nextStep, setNextStep] = useState({
        step0: true,  // 🔹 теперь это "Insert link → Grab from Amazon"
        step1: false, // дальше всё как у тебя
        step2: false,
        step3: false,
        step4: false,
        step5: false,
        step6: false,
    });

    const wordCountOptions = [
        { id: 1, count: 1000, label: "About 1,000" },
        { id: 2, count: 5000, label: "About 5,000" },
        { id: 3, count: 10000, label: "About 10,000" },
        { id: 4, count: 15000, label: "About 15,000" },
        { id: 5, count: 20000, label: "About 20,000" },
        { id: 6, count: 25000, label: "About 25,000" },
        { id: 7, count: 30000, label: "About 30,000" },
        { id: 8, count: 35000, label: "About 35,000" },
        { id: 9, count: 40000, label: "About 40,000" },
        { id: 10, count: 45000, label: "About 45,000" },
        { id: 11, count: 50000, label: "About 50,000" },
        { id: 12, count: 60000, label: "About 60,000" },
        { id: 13, count: 75000, label: "About 75,000" },
        { id: 14, count: 85000, label: "About 85,000" },
        { id: 15, count: 100000, label: "About 100,000" },
        { id: 16, count: 120000, label: "More then 120,000" },
    ];

    // 📌 Соотношения сторон для разных форматов книг
    const bookSizes = {
        "6x9": { aspectRatio: 6 / 9 },
        "8.5x11": { aspectRatio: 8.5 / 11 },
        "8.5x8.5": { aspectRatio: 8.5 / 8.5 },
        "8x10": { aspectRatio: 8 / 10 },
        "5x8": { aspectRatio: 5 / 8 },
        "7x10": { aspectRatio: 7 / 10 },
    };
    const [pdffile, setPdfFile] = useState(null)
    const [tempPDFFile, setTempPDFFile] = useState(''); // Для временного файла
    const [uploadProgress, setUploadProgress] = useState(0); // Для прогресса загрузки
    const [pdfFileTitle, setPdfFileTitle] = useState("")

    const [progress, setProgress] = useState(0);





    // ---- utils: скачиваем картинку как File ----
    const fetchCoverDirect = async (url) => {
        // пробуем напрямую (может сработать, если CORS открыт)
        const resp = await fetch(url, { credentials: 'omit', mode: 'cors' });
        if (!resp.ok) throw new Error(`direct fetch failed: ${resp.status}`);
        const blob = await resp.blob();
        return { blob, contentType: blob.type || 'image/jpeg' };
    };

    const blobToFile = (blob, contentType, filenameHint = 'cover') => {
        const ext = (contentType.split('/')[1] || 'jpg').split(';')[0];
        return new File([blob], `${filenameHint}.${ext}`, { type: contentType });
    };

    const blobToBase64 = (blob) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });

    /**
     * Скачиваем картинку по URL -> кладём в состояния coverFileState + coverPreview.
     * Сначала прямой fetch, если не получится — через прокси.
     */
    const downloadAndSetCover = async (imageUrl, filenameHint = 'cover') => {
        if (!imageUrl) return;

        try {
            let got;
            try {
                got = await fetchCoverDirect(imageUrl);
            } catch {
                //   got = await fetchCoverViaProxy(imageUrl);
            }

            const file = blobToFile(got.blob, got.contentType, filenameHint);
            setCoverFileState(file);                       // для FormData
            const base64 = await blobToBase64(file);       // для превью/LS (как у тебя и было)
            setCoverPreview(base64);

            // сохраним в localStorage (совместимо с твоей логикой восстановления)
            saveBookDataToLocalStorage({
                cover_file: base64,
                cover_file_name: file.name,
            });

        } catch (err) {
            console.error('Cover download failed:', err);
            toast.warn('Could not download cover automatically. You can upload it manually.', { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        }
    };

    // helper: форматируем число или пустую строку
    const safeVal = (v) => (typeof v === 'number' && Number.isFinite(v)) ? v.toFixed(2) : '';


    // ——— нормализация текста
    const norm = (s) => (s || "")
        .toString()
        .toLowerCase()
        .replace(/[^\p{L}\p{N}&+ ]/gu, " ")
        .replace(/\s+/g, " ")
        .trim();

// ——— подобрать язык из book.languages по строке с Амазона (например "English")
    const autoMatchLanguage = (langStr, languagesList) => {
        if (!langStr || !Array.isArray(languagesList) || !languagesList.length) return null;
        const n = norm(langStr);

        // 1) точное совпадение по полю language
        let hit = languagesList.find(l => norm(l.language) === n);
        if (hit) return hit;

        // 2) включение/частичное совпадение (например "English (US)")
        hit = languagesList.find(l => n.includes(norm(l.language)) || norm(l.language).includes(n));
        if (hit) return hit;

        // 3) простые синонимы → к нашим названиям
        const syn = {
            "portuguese (brazilian)": "Portuguese",
            "portuguese (european)": "Portuguese",
            "chinese (simplified)": "Chinese",
            "chinese (traditional)": "Chinese",
            "serbo-croatian": "Serbian",
        };
        const mapped = syn[n];
        if (mapped) {
            hit = languagesList.find(l => norm(l.language) === norm(mapped));
            if (hit) return hit;
        }

        return null;
    };

// ——— оценить кол-во слов по количеству печатных страниц и выбрать ближайший bucket
    const estimateWordCountBucket = (pages, buckets) => {
        const p = Number(pages) || 0;
        // типичный trade paperback 250–300 слов/страницу; берём 275 как “серединку”
        const words = Math.max(250, Math.round(p * 275));
        let best = buckets[0];
        let bestDiff = Math.abs(words - buckets[0].count);
        for (const b of buckets) {
            const d = Math.abs(words - b.count);
            if (d < bestDiff) { best = b; bestDiff = d; }
        }
        return best;
    };

// ——— подобрать жанр из book.genres по пути категорий/крошкам Amazon
    const autoPickGenre = (catsArr, catsPath, allGenres) => {
        if (!Array.isArray(allGenres) || !allGenres.length) return null;
        const hay = norm([...(catsArr || [])].join(" › ") + " " + (catsPath || ""));

        // 1) прямые попадания по строкам жанров из БД
        const directMatches = allGenres.filter(g => hay.includes(norm(g.genre)));
        if (directMatches.length) {
            // берём самый “специфичный” (длиннейшая строка)
            return directMatches.sort((a,b)=>b.genre.length - a.genre.length)[0];
        }

        // 2) словарь синонимов/маппингов Amazon → наша FBA-категория
        const map = [
            // Home & Kitchen
            ["home & kitchen", "Home & Kitchen"],
            ["home decor", "Home & Kitchen"],
            ["small appliance", "Home & Kitchen"],
            ["vacuum", "Home & Kitchen"],
            ["humidifier", "Home & Kitchen"],

            // Kitchen & Dining
            ["kitchen & dining", "Kitchen & Dining"],
            ["cookware", "Kitchen & Dining"],
            ["bakeware", "Kitchen & Dining"],
            ["utensil", "Kitchen & Dining"],
            ["cutlery", "Kitchen & Dining"],
            ["food storage", "Kitchen & Dining"],
            ["water bottle", "Kitchen & Dining"],

            // Tools & Home Improvement
            ["tools & home improvement", "Tools & Home Improvement"],
            ["power tool", "Tools & Home Improvement"],
            ["hand tool", "Tools & Home Improvement"],
            ["hardware", "Tools & Home Improvement"],
            ["lighting", "Tools & Home Improvement"],
            ["door lock", "Tools & Home Improvement"],

            // Sports & Outdoors
            ["sports & outdoors", "Sports & Outdoors"],
            ["camp", "Sports & Outdoors"],
            ["hiking", "Sports & Outdoors"],
            ["fitness", "Sports & Outdoors"],
            ["yoga", "Sports & Outdoors"],
            ["cycling", "Sports & Outdoors"],

            // Health & Household
            ["health & household", "Health & Household"],
            ["vitamin", "Health & Household"],
            ["supplement", "Health & Household"],
            ["first aid", "Health & Household"],
            ["oral care", "Health & Household"],
            ["household supplies", "Health & Household"],

            // Beauty & Personal Care
            ["beauty & personal care", "Beauty & Personal Care"],
            ["skincare", "Beauty & Personal Care"],
            ["makeup", "Beauty & Personal Care"],
            ["hair care", "Beauty & Personal Care"],
            ["shampoo", "Beauty & Personal Care"],
            ["lotion", "Beauty & Personal Care"],

            // Pet Supplies
            ["pet supplies", "Pet Supplies"],
            ["dog", "Pet Supplies"],
            ["cat", "Pet Supplies"],
            ["pet toy", "Pet Supplies"],
            ["pet grooming", "Pet Supplies"],
            ["litter", "Pet Supplies"],

            // Baby Products
            ["baby", "Baby Products"],
            ["stroller", "Baby Products"],
            ["diaper", "Baby Products"],
            ["bottle warmer", "Baby Products"],
            ["pacifier", "Baby Products"],

            // Toys & Games
            ["toys & games", "Toys & Games"],
            ["board game", "Toys & Games"],
            ["puzzle", "Toys & Games"],
            ["building set", "Toys & Games"],
            ["rc car", "Toys & Games"],

            // Office Products
            ["office products", "Office Products"],
            ["stationery", "Office Products"],
            ["printer paper", "Office Products"],
            ["laminator", "Office Products"],
            ["desk organizer", "Office Products"],

            // Arts, Crafts & Sewing
            ["arts", "Arts, Crafts & Sewing"],
            ["craft", "Arts, Crafts & Sewing"],
            ["sewing", "Arts, Crafts & Sewing"],
            ["yarn", "Arts, Crafts & Sewing"],
            ["embroidery", "Arts, Crafts & Sewing"],

            // Patio, Lawn & Garden
            ["patio", "Patio, Lawn & Garden"],
            ["lawn & garden", "Patio, Lawn & Garden"],
            ["outdoor", "Patio, Lawn & Garden"],
            ["grill", "Patio, Lawn & Garden"],
            ["planter", "Patio, Lawn & Garden"],

            // Automotive
            ["automotive", "Automotive"],
            ["car accessory", "Automotive"],
            ["car care", "Automotive"],
            ["floor mat", "Automotive"],
            ["dash cam", "Automotive"],

            // Industrial & Scientific
            ["industrial & scientific", "Industrial & Scientific"],
            ["lab", "Industrial & Scientific"],
            ["safety", "Industrial & Scientific"],
            ["measurement", "Industrial & Scientific"],

            // Grocery & Gourmet Food
            ["grocery", "Grocery & Gourmet Food"],
            ["snack", "Grocery & Gourmet Food"],
            ["coffee", "Grocery & Gourmet Food"],
            ["tea", "Grocery & Gourmet Food"],
            ["spice", "Grocery & Gourmet Food"],

            // Electronics Accessories
            ["electronics", "Electronics Accessories"],
            ["usb", "Electronics Accessories"],
            ["hdmi", "Electronics Accessories"],
            ["adapter", "Electronics Accessories"],
            ["memory card", "Electronics Accessories"],

            // Cell Phones & Accessories
            ["cell phone", "Cell Phones & Accessories"],
            ["phone case", "Cell Phones & Accessories"],
            ["screen protector", "Cell Phones & Accessories"],
            ["wireless charger", "Cell Phones & Accessories"],

            // Home Storage & Organization
            ["storage bin", "Home Storage & Organization"],
            ["closet organizer", "Home Storage & Organization"],
            ["shelf", "Home Storage & Organization"],
            ["under bed storage", "Home Storage & Organization"],

            // Bedding & Bath
            ["bedding", "Bedding & Bath"],
            ["duvet", "Bedding & Bath"],
            ["sheet set", "Bedding & Bath"],
            ["bath towel", "Bedding & Bath"],
            ["shower curtain", "Bedding & Bath"],

            // Musical Instruments
            ["musical instrument", "Musical Instruments"],
            ["guitar", "Musical Instruments"],
            ["keyboard", "Musical Instruments"],
            ["mic", "Musical Instruments"],
            ["drum", "Musical Instruments"],
        ];


        for (const [needle, target] of map) {
            if (hay.includes(needle)) {
                const g = allGenres.find(x => x.genre === target);
                if (g) return g;
            }
        }
        return null;
    };


    // 🔹 Resize editor
    useEffect(() => {
        const updateSize = () => {
            if (parentRef.current) {
                const parentWidth = parentRef.current.clientWidth;
                const selectedSize = bookSizes[bookFormat] || bookSizes["6x9"];
                const newHeight = parentWidth / selectedSize.aspectRatio;
                setEditorSize({ width: parentWidth, height: newHeight });
            }
        };
        updateSize();
        window.addEventListener("resize", updateSize);
        return () => window.removeEventListener("resize", updateSize);
    }, [bookFormat]);

    useEffect(() => {
        const savedPdfFileTitle = localStorage.getItem("pdf_file_title");
        const savedTempPDFFile = localStorage.getItem("temp_pdf_file");
        if (savedPdfFileTitle) setPdfFileTitle(savedPdfFileTitle);
        if (savedTempPDFFile) setTempPDFFile(savedTempPDFFile);
    }, []);

    useEffect(() => {
        loadBookDataFromLocalStorage();
    }, []);

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setNewdBook((prevBook) => {
            let updatedBook = { ...prevBook, [name]: checked };

            if (name === "audio_exclusive_flag" && checked) {
                updatedBook.audio_non_exclusive_flag = false;
            }
            if (name === "audio_non_exclusive_flag" && checked) {
                updatedBook.audio_exclusive_flag = false;
            }
            if (name === "audio_flag" && !checked) {
                updatedBook.audio_exclusive_flag = false;
                updatedBook.audio_non_exclusive_flag = false;
            }
            if (name === "kindle_flag" && !checked) {
                updatedBook.kindle_unlimited_flag = false;
            }
            return updatedBook;
        });
    };

    const isFormValid =
        user.user.id &&
        book.selectedGenre.id &&
        book.selectedLanguage.id &&
        titleState &&
        subtitleState &&
        authorState &&
        summaryState &&
        (newBook.paper_back_flag ||
            newBook.kindle_flag ||
            newBook.hard_cover_flag ||
            newBook.audio_flag ||
            newBook.kindle_unlimited_flag) &&
        (paperbackAsinState || kindleAsinState || hardcoverAsinState || audioAsinState) &&
        coverFileState &&
        (
            noManuscript ||
            (tempPDFFile && pdfFileTitle)
        )
        && (!newBook.audio_non_exclusive_flag || audioBookLinkState);

    const handleSubmitBookToModeration = () => {
        const trimmedTitle = titleState.trim();
        const trimmedAuthor = authorState.trim();
        const trimmedSubtitle = subtitleState.trim();
        setTitleState(trimmedTitle);
        setAuthorState(trimmedAuthor);
        setSubTitleState(trimmedSubtitle);

        if (!isFormValid) {
            toast.warn("Fill all fields, please!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }
        addBook();
    };

    // ==== LocalStorage helpers ====
    const saveBookDataToLocalStorage = (updatedFields = {}) => {
        const existingData = JSON.parse(localStorage.getItem("bookForm")) || {};
        const bookData = {
            ...existingData,
            ...updatedFields,
        };
        if (updatedFields.no_manuscript !== undefined) {
            bookData.no_manuscript = updatedFields.no_manuscript ? true : false;
        }
        if (updatedFields.public_catalog_visible !== undefined) {
            bookData.public_catalog_visible = updatedFields.public_catalog_visible ? true : false;
        }
        localStorage.setItem("bookForm", JSON.stringify(bookData));

    };

    const loadBookDataFromLocalStorage = () => {
        const savedData = localStorage.getItem("bookForm");
        if (savedData) {
            const bookData = JSON.parse(savedData);
            setTitleState(bookData.title || "");
            setSubTitleState(bookData.subtitle || "");
            setAuthorState(bookData.author || "");
            setSummaryState(bookData.summary || "");
            setPaperBackAsinState(bookData.pb_asin || "");
            setAmzlinkState(bookData.amz_link || "");
            setKindleAsinState(bookData.k_asin || "");
            setHardCoverAsinState(bookData.hc_asin || "");
            setAudioAsinState(bookData.audio_asin || "");
            setAudibleAsinState(bookData.audible_asin || "");
            setAudioBookLinkState(bookData.audible_link || "");
            setSummaryState(bookData.summary || "");

            setTempPDFFile(bookData.book_temp_file_name || "");
            setTempPDFFile(bookData.temp_pdf_file || "");
            setPdfFileTitle(bookData.pdf_file_title || "");
            if (bookData.no_manuscript !== undefined) {
                setNoManuscript(!!bookData.no_manuscript);
            }
            if (bookData.public_catalog_visible !== undefined) {
                setPublicCatalogVisible(bookData.public_catalog_visible !== false);
            }

            if (bookData.cover_file) {
                const restoredBlob = base64ToBlob(bookData.cover_file);
                const restoredFile = new File([restoredBlob], bookData.cover_file_name, { type: "image/jpeg" });
                setCoverFileState(restoredFile);
                setCoverPreview(bookData.cover_file);
            }

            book.setSelectedLanguage(bookData.language || {});
            book.setSelectedGenre(bookData.genre || {});
            setNewdBook((prev) => ({
                ...prev,
                paper_back_flag: bookData.bookTypes?.paperBack || false,
                kindle_flag: bookData.bookTypes?.kindle || false,
                hard_cover_flag: bookData.bookTypes?.hardCover || false,
                kindle_unlimited_flag: bookData.bookTypes?.kindle_u || false,
                audio_flag: bookData.bookTypes?.audio || false,
                audio_exclusive_flag: bookData.bookTypes?.audio_ex || false,
                audio_non_exclusive_flag: bookData.bookTypes?.audio_non_ex || false,
            }));
        }
    };

    const clearBookDataFromLocalStorage = () => {
        localStorage.removeItem("bookForm");
    };

    // ==== Upload PDF ====
    const selectBookFile = (e) => {
        const input = e.target;
        const file = input.files[0];
        input.value = "";

        if (!file) {
            toast.error("Error: No file selected.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }
        if (file.type !== "application/pdf") {
            toast.error(`Error: File "${file.name}" is not a PDF.`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }
        const maxFileSize = 500 * 1024 * 1024;
        if (file.size > maxFileSize) {
            toast.error(`Error: File "${file.name}" exceeds 500MB limit.`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        setPdfFile(file);
        setPdfFileTitle(file.name);
        saveBookDataToLocalStorage({ pdf_file_title: file.name });

        const formData = new FormData();
        formData.append("book_download_temp", file);

        try {
            const xhr = new XMLHttpRequest();
            xhr.open("POST", process.env.REACT_APP_API_URL + "api/book/temp", true);

            xhr.upload.onprogress = (event) => {
                if (event.lengthComputable) {
                    const percentComplete = Math.round((event.loaded / event.total) * 100);
                    setUploadProgress(percentComplete >= 100 ? 99 : percentComplete);
                }
            };

            xhr.onload = () => {
                if (xhr.status === 200) {
                    const response = JSON.parse(xhr.responseText);
                    const tempFileName = response.tempPDFFile;
                    toast.success(response.message, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                    setTempPDFFile(tempFileName);
                    saveBookDataToLocalStorage({ temp_pdf_file: tempFileName });
                    setUploadProgress(100);
                } else {
                    let errorMessage = `Upload failed: ${xhr.status}`;
                    try {
                        errorMessage = JSON.parse(xhr.responseText)?.message || errorMessage;
                    } catch (_) {}
                    toast.error(errorMessage, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                    setUploadProgress(-1);
                }
            };

            xhr.onerror = () => {
                toast.error("Error uploading file.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                setUploadProgress(-1);
            };

            xhr.send(formData);
        } catch (error) {
            toast.error(`Error sending file: ${error.message}`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        }
    };

    const triggerFileInputBook = () => {
        document.getElementById("fileInputBook").click();
    };

    const triggerFileInput = () => {
        const input = document.getElementById("fileInput");
        input.value = "";
        input.click();
    };

    const handleFileChange = (e) => {
        const input = e.target;
        const file = e.target.files[0];
        input.value = "";
        if (file && file.type.startsWith("image/")) {
            setOriginalCover(file);
            const reader = new FileReader();
            reader.onload = (event) => {
                const imageBase64 = event.target.result;
                setCoverPreview(imageBase64);
                setShowEditor(true);
                saveBookDataToLocalStorage({
                    cover_file: imageBase64,
                    cover_file_name: file.name,
                });
            };
            reader.readAsDataURL(file);
        }
    };

    const base64ToBlob = (base64) => {
        const byteCharacters = atob(base64.split(',')[1]);
        const byteArrays = [];
        for (let i = 0; i < byteCharacters.length; i++) {
            byteArrays.push(byteCharacters.charCodeAt(i));
        }
        return new Blob([new Uint8Array(byteArrays)], { type: 'image/jpeg' });
    };

    const resetDataFields = () => {
        localStorage.removeItem("temp_pdf_file");
        setTempPDFFile(null);
        setPdfFileTitle('');

        setTitleState('');
        setSubTitleState('');
        setAuthorState('');
        setSummaryState('');
        setAmzlinkState('');
        setPaperBackAsinState('');
        setKindleAsinState('');
        setHardCoverAsinState('');
        setAudioAsinState('');
        setAudibleAsinState('');
        setAudioBookLinkState('');
        setPdfFile(null);
        setSelectedWordCount({});
        setAmzlinkState('');
        setKindlePriceState('null');
        setPaperbackPriceState('null');
        setHardcoverPriceState(null);
        setFourthPriceState(null);

        book.setSelectedLanguage({});
        book.setSelectedGenre({});

        setCoverFileState(null);
        setCoverPreview(defaultImage);
        setOriginalCover(null);
        setShowEditor(false);
        setScale(1);
        setEditorRef(null);
        setDescription('');
        setNoManuscript(false);
    };

    const addBook = async () => {
        setLoading(true);
        setError('');
        try {
            const formData = new FormData();

            // ===== Price normalization helpers =====
            const normalizePrice = (val) => {
                if (val === undefined || val === null) return '';
                let s = String(val).trim();
                if (!s) return '';

                // remove spaces and currency symbols, keep digits, comma, dot, minus
                s = s.replace(/\s+/g, '').replace(/[^\d.,-]/g, '');

                // optional: forbid negative (strip all minus)
                s = s.replace(/-/g, '');

                // if there is neither comma nor dot → it's an integer already
                const lastComma = s.lastIndexOf(',');
                const lastDot   = s.lastIndexOf('.');
                if (lastComma === -1 && lastDot === -1) return s;

                // choose the rightmost of comma/dot as decimal separator
                const decPos = Math.max(lastComma, lastDot);
                const intPart  = s.slice(0, decPos).replace(/[.,]/g, ''); // remove thousands separators
                const fracPart = s.slice(decPos + 1).replace(/[.,]/g, ''); // keep only digits

                return fracPart ? `${intPart}.${fracPart}` : intPart; // "1234.56" or "1234"
            };

            const toPriceNumber = (val) => {
                const norm = normalizePrice(val);
                if (!norm) return undefined;
                const n = Number(norm);
                return Number.isFinite(n) ? n : undefined;
            };

            // ===== Price-specific append helpers (normalized) =====
            const appendPriceString = (key, value) => {
                const norm = normalizePrice(value);
                if (norm) formData.append(key, norm);
            };

            const appendPriceNumber = (key, value) => {
                const n = toPriceNumber(value);
                if (n !== undefined) formData.append(key, n);
            };

            // ==================================
            formData.append('userId', user.user.id);
            formData.append('booksGenreId', book.selectedGenre.id);
            formData.append('booksPriceId', 1);
            formData.append('booksLanguageId', book.selectedLanguage.id);
            formData.append('booksTypeId', 1);
            formData.append('title', titleState);
            formData.append('subtitle', subtitleState);
            formData.append('author', authorState);
            formData.append('book_type', 'product');
            formData.append('language', book.selectedLanguage.language);
            formData.append('amz_price', '');
            formData.append('summary', summaryState);
            formData.append('status', 'NEW');
            formData.append('message', '');
            formData.append('message_flag', false);
            formData.append('amz_link', '');
            formData.append('paper_back_flag', newBook.paper_back_flag);
            formData.append('kindle_flag', newBook.kindle_flag);
            formData.append('kindle_unlimited_flag', newBook.kindle_unlimited_flag);
            formData.append('audio_exclusive_flag', newBook.audio_exclusive_flag);
            formData.append('audio_non_exclusive_flag', newBook.audio_non_exclusive_flag);
            formData.append('hard_cover_flag', newBook.hard_cover_flag);
            formData.append('audio_flag', newBook.audio_flag);
            formData.append('default_price', 500);
            formData.append('default_decrement', 0);
            formData.append('paper_back_asin', paperbackAsinState || '');
            formData.append('kindle_asin', kindleAsinState || '');
            formData.append('hard_cover_asin', hardcoverAsinState || '');
            formData.append('audio_asin', audioAsinState || '');
            formData.append('audio_audible_asin', audibleAsinState || '');
            formData.append('audio_download_link_ned', audioBookLinkState || '');
            formData.append('total_words', selectedWordCount?.count || 1000);
            formData.append('description_full', description || summaryState || '');

            // ===== Prices (strings – normalized with dot) =====
            appendPriceString("kindle_price_on_amazon", kindlePriceState);
            appendPriceString("paper_back_price_on_amazon", paperbackPriceState);
            appendPriceString("hard_cover_price_on_amazon", hardcoverPriceState);
            appendPriceString("fourth_price_on_amazon", fourthPriceState);

            // ===== Prices (numbers – normalized) =====
            appendPriceNumber('kindle_list_price_on_amazon_decimal', kindlePriceState);
            appendPriceNumber('paper_back_list_price_on_amazon_decimal', paperbackPriceState);
            appendPriceNumber('hard_cover_list_price_on_amazon_decimal', hardcoverPriceState);
            appendPriceNumber('fourth_list_price_on_amazon_decimal', fourthPriceState);

            formData.append('no_manuscript', noManuscript ? '1' : '0');
            formData.append('public_catalog_visible', publicCatalogVisible ? '1' : '0');
            formData.append('last_update_book_data_from_amazon_date', Math.floor(Date.now()/1000));

            if (tempPDFFile) formData.append("book_download", tempPDFFile);
            if (coverFileState) {
                formData.append("cover_file", coverFileState);
            } else {
                toast.warn("No cover image found!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            }

            const result = await createBook(formData);

            const createdBook = result.book;

            toast.success(result.message, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });

            const updatedBooks = await fetchCurrentUserBooks(user?.user?.id);
            book.setCurrentUserBooks(updatedBooks);
            book.setSelectedCurrentUserBook({ formData });

            const foundBook = updatedBooks.find(b => b.id === createdBook.id);
            if (foundBook) {
                book.setSelectedCurrentUserBook(foundBook);
                user.setActiveComponent("BookFull");
            }

            clearBookDataFromLocalStorage();
            resetDataFields();
        } catch (e) {
            console.error(e);
            toast.error(`❌ Error: ${e.message}`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            setError(e.message || 'An error occurred while uploading your book.');
        } finally {
            setLoading(false);
        }
    };


    // 🔹 Шаг 0: граб из Amazon
    const fetchFromAmazon = async () => {
        const raw = (amzlinkState || "").trim();
        if (!raw) {
            toast.info("Paste your Amazon product link first.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }
        setLoading(true);
        try {
            const data = await getFullProductDataUrlApi(raw);

            await downloadAndSetCover(
                data?.main_image ||
                data?.image_large ||
                data?.image_medium ||
                (Array.isArray(data?.images) ? data.images[0] : '')
            );

            // Заголовки
            setTitleState(data?.title || "");
            setSubTitleState(data?.subtitle || "");
            const authorsStr = (data?.authors_str?.trim?.()) ||
                (Array.isArray(data?.authors) ? data.authors.join(", ") : "") || "";
            setAuthorState(authorsStr);

            //Description
            setSummaryState(data?.description_first10);

            // Флаги форматов
            setNewdBook(prev => ({
                ...prev,
                kindle_flag: !!data?.kindle,
                kindle_unlimited_flag: !!data?.kindle_unlimited,
                paper_back_flag: !!data?.pb,
                hard_cover_flag: !!data?.hc,
                audio_flag: !!data?.audio,
                // 98% кейсов — аудио эксклюзив; ставим true по умолчанию
                audio_exclusive_flag: !!data?.audio,
                audio_non_exclusive_flag: false, // дефолтно выключаем non-exclusive
            }));

            // ASINы
            setKindleAsinState(data?.kindle_asin || "");
            setPaperBackAsinState(data?.pb_asin || "");
            setHardCoverAsinState(data?.hc_asin || "");
            setAudioAsinState(data?.audio_asin || "");
            setAudibleAsinState(data?.audio_audible_asin || data?.audible_asin || "");
            setKindlePriceState(safeVal(data?.prices?.kindle?.value));
            setPaperbackPriceState(safeVal(data?.prices?.paperback?.value));
            setHardcoverPriceState(safeVal(data?.prices?.hardcover?.value));
            setFourthPriceState(safeVal(data?.prices?.audio?.value));

            // Превью обложки (URL). Это только превью — файл юзер всё равно загрузит на шаге обложки.
            if (data?.main_image) {
                setCoverPreview(data.main_image);
            }

            // ЯЗЫК
            if (data?.language && Array.isArray(book.languages) && book.languages.length) {
                const matchedLang = autoMatchLanguage(data.language, book.languages);
                if (matchedLang) {
                    book.setSelectedLanguage(matchedLang);
                    // можно сразу и в localStorage положить
                    saveBookDataToLocalStorage({ language: matchedLang });
                }
            }

            // ПРИБЛИЖЁННЫЙ ОБЪЁМ СЛОВ по print_length
            if (data?.print_length) {
                const bucket = estimateWordCountBucket(data.print_length, wordCountOptions);
                if (bucket) {
                    setSelectedWordCount(bucket);
                    saveBookDataToLocalStorage({ total_words: bucket.count });
                }
            }

            // ЖАНР по крошкам/категориям
            if ((data?.categories?.length || data?.categories_path) && Array.isArray(book.genres) && book.genres.length) {
                const guessed = autoPickGenre(data.categories || [], data.categories_path || "", book.genres);
                if (guessed) {
                    book.setSelectedGenre(guessed);
                    saveBookDataToLocalStorage({ genre: guessed });
                }
            }


            // Сохраним часть в localStorage, чтобы не потерялось при перезагрузке
            saveBookDataToLocalStorage({
                amz_link: raw,
                title: data?.title || "",
                subtitle: data?.subtitle || "",
                author: authorsStr,
                pb_asin: data?.pb_asin || "",
                k_asin: data?.kindle_asin || "",
                hc_asin: data?.hc_asin || "",
                audio_asin: data?.audio_asin || "",
                audible_asin: data?.audio_audible_asin || data?.audible_asin || "",
                summary: data?.description_first10 || "",
                bookTypes: {
                    paperBack: !!data?.pb,
                    kindle: !!data?.kindle,
                    kindle_u: !!data?.kindle_unlimited,
                    hardCover: !!data?.hc,
                    audio: !!data?.audio,
                    audio_ex: false,
                    audio_non_ex: false,
                }
            });

            toast.success("Done! Double-Check the Details!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });

            // Автопереход на следующий шаг (к твоему прежнему Step 1 — выбор языка/жанра/типов)
            setNextStep({
                step0: false,
                step1: true,
                step2: false,
                step3: false,
                step4: false,
                step5: false,
                step6: false
            });
            setStep(1);

            // допустим, после удачного ответа grab-функции:
            const imgUrl =
                data?.main_image ||
                data?.image_large ||
                data?.image_medium ||
                (Array.isArray(data?.images) ? data.images[0] : '') ||
                '';

            if (imgUrl) {
                await downloadAndSetCover(imgUrl, (data?.title || 'cover').replace(/[^\w-]+/g, '_'));
            }

        } catch (e) {
            console.error(e);
            toast.error(`Grab failed: ${e?.response?.data?.message || e.message}`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (error) {
            toast.error(`❌ ${error}`, { closeOnClick: true, pauseOnHover: true, draggable: true, theme: 'colored', position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        }
    }, [error]);

    const addProductInDash = () => {
        user?.setActiveComponent("AddProductInDashboard");
    }
    const autoAddProductInDash = () => {
        user?.setActiveComponent("AddProductByGrabFromAmazon");
    }
    useEffect(() => {
        if (loading) {
            setProgress(0);
            const start = Date.now();
            const timer = setInterval(() => {
                const elapsed = Date.now() - start;
                const pct = Math.min(100, (elapsed / 1500) * 100); // за 1.5 секунду доходит до 100
                setProgress(pct);
                if (pct >= 100) clearInterval(timer);
            }, 50);
            return () => clearInterval(timer);
        }
    }, [loading]);


    return (
        <>
            <Card className="p-3 w-100 mt-2">
                {/* Header: title + Back button on step > 0 */}
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center flex-wrap gap-2">
                    {/* Header: title + Back button on step > 0 */}
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center flex-wrap gap-2 w-100">
                        <h5 className="text-muted mb-2 mb-md-0">
                            {step === 0
                                ? "Automatically Add a New FBA Product to Virtalibry System:"
                                : "Great! Review Everything, then click Submit for Moderation:"}
                        </h5>

                        {/* Кнопки Manual / Automatic справа */}
                        {step === 0 && (<>
                            <ButtonGroup>
                                <Button
                                    variant={user?.activeComponent === "AddProductByGrabFromAmazon" ? "success" : "outline-success"}
                                    size="sm"
                                    onClick={autoAddProductInDash}
                                >
                                    Automatically
                                </Button>
                                <Button
                                    variant={user?.activeComponent === "AddProductInDashboard" ? "success" : "outline-success"}
                                    size="sm"
                                    onClick={addProductInDash}
                                >
                                    Manually
                                </Button>
                            </ButtonGroup>
                        </>)}
                        {step > 0 && (
                            <Button
                                className="d-inline-flex align-items-center border btn-secondary btn-sm"
                                onClick={() => {
                                    setNextStep({
                                        step0: true, step1: false, step2: false, step3: false, step4: false, step5: false, step6: false
                                    });
                                    setStep(0); // вернуться к полю линка, данные не очищаем
                                }}
                                title="Back to Step 1"
                            >
                                <i className="me-2 fas fa-arrow-circle-left"></i> Back
                            </Button>

                        )}

                    </div>



                </div>

                {/* === STEP 0: только линк + Grab === */}
                {step === 0 && (<>
                    <div className="text-muted small">
                        <p className="mb-1 mt-2">
                            In <strong>Automatic Mode</strong>, Virtalibry will automatically fetch and clean product data from Amazon. Requires two simple steps.
                        </p>

                        <p className="mb-1">
                            <strong>Step 1:</strong> Paste your <em>Amazon product link</em> and click <em>Fetch Product Data from Amazon</em>.
                            Virtalibry will automatically collect the key information such as <em>Product Title</em>, <em>Brand</em>, <em>Category</em>, <em>Language</em> (if applicable), <em>ASIN</em>, <em>Price</em>, available <em>Variants</em> (color, size, etc.), <em>Product Description</em> (first 10 lines), and <em>Main Image</em>. Unnecessary labels like “by” or “Brand:” will be removed automatically.
                        </p>

                        <p className="mb-1">
                            <strong>Step 2:</strong> Review the imported data, make any corrections if needed, upload your <em>supporting files or documents</em> (if required),
                            and click <em>Submit for Moderation</em>.
                            Double-check that the product title, brand, and ASIN match exactly with your Amazon listing.
                            Use the <em>Check</em> buttons next to each ASIN or link to confirm that they open the correct product page.
                            Once everything looks correct, click <strong>Submit for Moderation</strong> — and your product will be sent for review.
                        </p>
                    </div>


                    <Col md={12} className="mt-2">
                        <Card className="mt-2 mb-2 border rounded-1 border-secondary ">
                            <Card.Header className="py-1 small">Fetch Product Data from Amazon. Insert Link, Grab, then continue.</Card.Header>
                            <Card.Body className="pt-2">
                                <Form
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        fetchFromAmazon();
                                        const link = amzlinkState.trim();
                                        saveBookDataToLocalStorage({ amz_link: link });
                                    }}
                                    className="small"
                                >
                                    <InputGroup className="mb-2 mt-2 border rounded-1 border-secondary" size="sm">
                                        <Form.Control
                                            type="text"
                                            placeholder="Paste your Amazon product link…"
                                            value={amzlinkState}
                                            onChange={(e) => setAmzlinkState(e.target.value)}
                                            disabled={loading}
                                            size="sm"
                                            className="border "
                                        />
                                        <Button
                                            variant="success"
                                            onClick={fetchFromAmazon}
                                            disabled={loading}
                                            type="button"
                                            size="sm"
                                            className="d-flex align-items-center justify-content-center"
                                            title="Grab and parse product data from Amazon"
                                        >
                                            {loading ? (
                                                <>
                                                    <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                        className="me-2"
                                                    />
                                                    Fetching Product Data…
                                                </>
                                            ) : (
                                                <>
                                                    <span className="d-none d-sm-inline">Fetch Product Data from Amazon</span>
                                                    <span className="d-inline d-sm-none">Fetch</span>
                                                </>
                                            )}
                                        </Button>

                                    </InputGroup>
                                    <div className="text-muted small">
                                        Paste the full product URL from Amazon (e.g. https://www.amazon.com/dp/XXXXXXXXXX) and press <strong>Fetch Product Data from Amazon</strong>.
                                    </div>
                                </Form>
                                {loading && (
                                    <div className="mt-2 w-100">
                                        <ProgressBar animated now={progress} variant="success" />
                                        <div className="small text-muted mt-1 text-center">
                                            We’re grabbing your product details, almost there…
                                        </div>
                                    </div>
                                )}

                            </Card.Body>
                        </Card>
                    </Col>
                </>)}

                {/* === STEP >= 1: верстка как в Edit (бордеры secondary) === */}
                {step > 0 && (

                    <Form className="mt-2 mb-0">
                        <div className="text-muted small">
                            <p className="mb-1 mt-2">
                                Check the retrieved data carefully — pay special attention to the prices for your product variations. Unfortunately, the Amazon product page doesn’t always provide accurate pricing information for different variations such as sizes, colors, or other types.
                            </p>
                        </div>
                        {/* ===== Title / Subtitle / Author ===== */}
                        <Row className="mb-0 mt-0 p-2 small">
                            <Col md={8}>
                                <Form.Group className="mb-0">
                                    <Form.Label className="text-muted fw-semibold mb-0">Amazon Product Title:</Form.Label>
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        placeholder="Enter book title"
                                        value={titleState}
                                        onChange={e => {
                                            const raw = e.target.value;
                                            const noCyrillic = raw.replace(/[а-яёА-ЯЁ]/g, '');
                                            setTitleState(noCyrillic);
                                        }}
                                        onBlur={() => setTitleState((v) => (v || '').replace(/[:]+$/, '').trim())}
                                        disabled={loading}
                                        className="border "
                                    />
                                </Form.Group>
                            </Col>

                               <Col md={2}>
                                <Form.Group className="mb-0">
                                    <Form.Label className="text-muted fw-semibold mb-0">Manufacturer:</Form.Label>
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        placeholder="Enter Product Manufacturer"
                                        value={subtitleState}
                                        onChange={e => {
                                            const raw = e.target.value;
                                            const noCyrillic = raw.replace(/[а-яёА-ЯЁ]/g, '');
                                            setSubTitleState(noCyrillic);
                                        }}
                                        onBlur={() => setSubTitleState((v) => (v || '').replace(/[:]+$/, '').trim())}
                                        disabled={loading}
                                        className="border "
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={2}>
                                <Form.Group className="mb-0">
                                    <Form.Label className="text-muted fw-semibold mb-0">Sold by:</Form.Label>
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        placeholder="Enter Seller Name"
                                        value={authorState}
                                        onChange={e => {
                                            const raw = e.target.value;
                                            const noCyrillic = raw.replace(/[а-яёА-ЯЁ]/g, '');
                                            setAuthorState(noCyrillic);
                                        }}
                                        onBlur={() => setAuthorState((v) => (v || '').replace(/:/g, '').trim())}
                                        disabled={loading}
                                        className="border "
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* ===== Language / Word Count / Genre ===== */}
                        <Row className="mb-0 p-2 flex-column flex-md-row small">
                            <Col xs={12} md={4} className="pe-md-2 mb-2 mb-md-0">
                                {/* Category of Product */}
                                <Card className="p-3 border mb-0">
                                <div className="d-flex flex-column mt-0">
                                    <span className="text-muted fw-semibold mb-1">Category of Product:</span>
                                    <Dropdown>
                                        <Dropdown.Toggle
                                            variant="small"
                                            size="sm"
                                            className="w-100 border small bg-white text-start"
                                        >
                                            {book.selectedGenre?.genre || "Select Category"}
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu style={{ maxHeight: "200px", overflowY: "auto" }}>
                                            {book.genres
                                                .filter((gen) => gen.type === "product")
                                                .map((gen) => (
                                                    <Dropdown.Item
                                                        onClick={() => book.setSelectedGenre(gen)}
                                                        key={gen.id}
                                                        className="small text-muted"
                                                    >
                                                        {gen.genre}
                                                    </Dropdown.Item>
                                                ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    <div className="d-flex flex-column mt-2 flex-md-row gap-2">

                                        {/* Language */}
                                        <div className="flex-grow-1">
                                            <span className="text-muted fw-semibold mb-1 d-block">Language:</span>
                                            <Dropdown>
                                                <Dropdown.Toggle
                                                    variant="small"
                                                    size="sm"
                                                    className="w-100 border small bg-white text-start"
                                                >
                                                    {book.selectedLanguage?.language || "Select language"}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu style={{ maxHeight: "200px", overflowY: "auto" }}>
                                                    {book.languages.map((lang) => (
                                                        <Dropdown.Item
                                                            onClick={() => book.setSelectedLanguage(lang)}
                                                            key={lang.id}
                                                            className="small text-muted"
                                                        >
                                                            {lang.language}
                                                        </Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>


                                    </div>
                                    <div className="flex-grow-1">
  <span className="text-muted fw-semibold mt-2 mb-1 d-block">
    Select Asin's quantity:
  </span>

                                        <Card className="p-2 mt-0 border ">
                                            <Row>
                                                <Col xs={6}>
                                                    <Form.Check
                                                        className="custom-checkbox mb-1"
                                                        type="checkbox"
                                                        label="First Asin"
                                                        name="kindle_flag"
                                                        checked={newBook.kindle_flag}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                    <Form.Check
                                                        className="custom-checkbox mb-1"
                                                        type="checkbox"
                                                        label="Second Asin"
                                                        name="paper_back_flag"
                                                        checked={newBook.paper_back_flag}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                </Col>

                                                <Col xs={6}>
                                                    <Form.Check
                                                        className="custom-checkbox mb-1"
                                                        type="checkbox"
                                                        label="Third Asin"
                                                        name="hard_cover_flag"
                                                        checked={newBook.hard_cover_flag}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                    <Form.Check
                                                        className="custom-checkbox mb-0"
                                                        type="checkbox"
                                                        label="Fourth Asin"
                                                        name="audio_flag"
                                                        checked={newBook.audio_flag}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                </Col>
                                            </Row>
                                        </Card>
                                    </div>


                                </div>
                                </Card>
                            </Col>

                            {/* Types (Kindle/Paperback/Hardcover/Audio) */}
                            <Col xs={12} md={8} className="px-md-2 mb-3 mb-md-0">
                                <Card className="p-2">
                                    <Row className="mb-2">
                                        {(newBook.paper_back_flag || newBook.kindle_flag) && (
                                            <Col md={6} style={{ maxWidth: "100%" }}>
                                                {newBook.kindle_flag && (
                                                    <Form className="mt-0 mb-0 p-1">
                                                        <Form.Label className="text-muted fw-semibold mb-0">First ASIN:</Form.Label>
                                                        <div className="d-flex align-items-center">
                                                            <Form.Control
                                                                className="border border-secondary form-control-sm"
                                                                value={kindleAsinState}
                                                                onChange={(e) => {
                                                                    const upper = e.target.value.replace(/\s/g, "").toUpperCase();
                                                                    setKindleAsinState(upper);
                                                                }}
                                                                placeholder="Enter First ASIN..."
                                                                disabled={loading}
                                                            />
                                                            <Button
                                                                variant="info"
                                                                className="ms-2 btn-sm"
                                                                disabled={!kindleAsinState}
                                                                onClick={async () => {
                                                                    try {
                                                                        const targetUrl = `${user?.user?.amz_country}/dp/${kindleAsinState}`;
                                                                        const response = await getRedirectUrlApi(targetUrl);
                                                                        if (response?.redirectUrl) {
                                                                            window.open(response.redirectUrl, "_blank", "noopener noreferrer");
                                                                        } else {
                                                                            console.error("Failed to get redirect URL");
                                                                        }
                                                                    } catch (err) {
                                                                        console.error("Redirect error:", err);
                                                                    }
                                                                }}
                                                            >
                                                                Check
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                )}

                                                {newBook.paper_back_flag && (
                                                    <Form className="mt-0 mb-0 p-1">
                                                        <div className="fw-semibold mb-0 text-muted">Second ASIN:</div>
                                                        <div className="d-flex align-items-center">
                                                            <Form.Control
                                                                className="border border-secondary form-control-sm"
                                                                value={paperbackAsinState}
                                                                onChange={(e) => {
                                                                    const cleaned = e.target.value.trim().toUpperCase();
                                                                    setPaperBackAsinState(cleaned);
                                                                }}
                                                                placeholder="Enter Second ASIN..."
                                                                disabled={loading}
                                                            />
                                                            <Button
                                                                variant="info"
                                                                className="ms-2 btn-sm"
                                                                disabled={!paperbackAsinState}
                                                                onClick={async () => {
                                                                    try {
                                                                        const targetUrl = `${user?.user?.amz_country}/dp/${paperbackAsinState}`;
                                                                        const response = await getRedirectUrlApi(targetUrl);
                                                                        if (response?.redirectUrl) {
                                                                            window.open(response.redirectUrl, "_blank", "noopener noreferrer");
                                                                        } else {
                                                                            console.error("Failed to get redirect URL");
                                                                        }
                                                                    } catch (err) {
                                                                        console.error("Redirect error:", err);
                                                                    }
                                                                }}
                                                            >
                                                                Check
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                )}

                                            </Col>
                                        )}

                                        {/* Если первая колонка есть → вторая md=6, иначе md=8 (как у тебя было) */}
                                        <Col md={newBook.paper_back_flag || newBook.kindle_flag ? 6 : 8} style={{ maxWidth: "100%" }}>
                                            {newBook.hard_cover_flag && (
                                                <Form className="mt-0 mb-0 p-1">
                                                    <div className="fw-semibold mb-0 text-muted">Third ASIN:</div>
                                                    <div className="d-flex align-items-center">
                                                        <Form.Control
                                                            className="border border-secondary form-control-sm"
                                                            value={hardcoverAsinState}
                                                            onChange={(e) => {
                                                                const cleaned = e.target.value.replace(/\s/g, "").toUpperCase();
                                                                setHardCoverAsinState(cleaned);
                                                            }}
                                                            placeholder="Enter Third ASIN..."
                                                            disabled={loading}
                                                        />
                                                        <Button
                                                            variant="info"
                                                            className="ms-2 btn-sm"
                                                            disabled={!hardcoverAsinState}
                                                            onClick={async () => {
                                                                try {
                                                                    const targetUrl = `${user?.user?.amz_country}/dp/${hardcoverAsinState}`;
                                                                    const response = await getRedirectUrlApi(targetUrl);
                                                                    if (response?.redirectUrl) {
                                                                        window.open(response.redirectUrl, "_blank", "noopener noreferrer");
                                                                    } else {
                                                                        console.error("Failed to get redirect URL");
                                                                    }
                                                                } catch (err) {
                                                                    console.error("Redirect error:", err);
                                                                }
                                                            }}
                                                        >
                                                            Check
                                                        </Button>
                                                    </div>
                                                </Form>
                                            )}

                                            {newBook.audio_flag && (
                                                <Form className="mt-0 mb-0 p-1">
                                                    <div className="fw-semibold mb-0 text-muted">Fourth ASIN:</div>
                                                    <div className="d-flex align-items-center">
                                                        <Form.Control
                                                            className="border border-secondary form-control-sm"
                                                            value={audioAsinState}
                                                            onChange={(e) => {
                                                                const cleaned = e.target.value.replace(/\s/g, "").toUpperCase();
                                                                setAudioAsinState(cleaned);
                                                            }}
                                                            placeholder="Enter Fourth ASIN..."
                                                            disabled={loading}
                                                        />
                                                        <Button
                                                            variant="info"
                                                            className="ms-2 btn-sm"
                                                            disabled={!audioAsinState}
                                                            onClick={async () => {
                                                                try {
                                                                    const targetUrl = `${user?.user?.amz_country}/dp/${audioAsinState}`;
                                                                    const response = await getRedirectUrlApi(targetUrl);
                                                                    if (response?.redirectUrl) {
                                                                        window.open(response.redirectUrl, "_blank", "noopener noreferrer");
                                                                    } else {
                                                                        console.error("Failed to get redirect URL");
                                                                    }
                                                                } catch (err) {
                                                                    console.error("Redirect error:", err);
                                                                }
                                                            }}
                                                        >
                                                            Check
                                                        </Button>
                                                    </div>
                                                </Form>
                                            )}
                                        </Col>
                                        <Row>
                                            <Card.Body>
                                                <Form className="m-0 mb-0">

                                                    {/* ===== MOBILE (xs–sm): полноширинные поля и кнопки ===== */}
                                                    <div className="d-flex d-md-none flex-column gap-2">
                                                        {/* Цены */}
                                                        {newBook.kindle_flag && (
                                                            <div className="d-flex flex-column">
                                                                <Form.Label className="text-muted fw-semibold mb-1">First Price:</Form.Label>
                                                                <Form.Control
                                                                    size="sm"
                                                                    type="text"
                                                                    inputMode="decimal"
                                                                    pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                    placeholder="First Price"
                                                                    value={kindlePriceState}
                                                                    disabled={loading}
                                                                    onChange={(e) => setKindlePriceState(e.target.value)}
                                                                />
                                                            </div>
                                                        )}

                                                        {newBook.paper_back_flag && (
                                                            <div className="d-flex flex-column">
                                                                <Form.Label className="text-muted fw-semibold mb-1">Second:</Form.Label>
                                                                <Form.Control
                                                                    size="sm"
                                                                    type="text"
                                                                    inputMode="decimal"
                                                                    pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                    placeholder="Second Price"
                                                                    value={paperbackPriceState}
                                                                    disabled={loading}
                                                                    onChange={(e) => setPaperbackPriceState(e.target.value)}
                                                                />
                                                            </div>
                                                        )}

                                                        {newBook.hard_cover_flag && (
                                                            <div className="d-flex flex-column">
                                                                <Form.Label className="text-muted fw-semibold mb-1">Third:</Form.Label>
                                                                <Form.Control
                                                                    size="sm"
                                                                    type="text"
                                                                    inputMode="decimal"
                                                                    pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                    placeholder="Third Price"
                                                                    value={hardcoverPriceState}
                                                                    disabled={loading}
                                                                    onChange={(e) => setHardcoverPriceState(e.target.value)}
                                                                />
                                                            </div>
                                                        )}
                                                        {newBook.audio_flag && (
                                                            <div className="d-flex flex-column">
                                                                <Form.Label className="text-muted fw-semibold mb-1">Fourth:</Form.Label>
                                                                <Form.Control
                                                                    size="sm"
                                                                    type="text"
                                                                    inputMode="decimal"
                                                                    pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                    placeholder="Fourth Price"
                                                                    value={fourthPriceState}
                                                                    disabled={loading}
                                                                    onChange={(e) => setFourthPriceState(e.target.value)}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* ===== DESKTOP (≥ md): исходная разметка без изменений ===== */}
                                                    <div className="d-none d-md-flex flex-wrap align-items-end gap-0 mt-0 mb-0">
                                                        {/* левая группа полей */}
                                                        <div className="d-flex flex-wrap align-items-end gap-3 flex-grow-1">
                                                            {newBook.kindle_flag && (
                                                                <div className="d-flex flex-column mt-0" style={{ minWidth: 50, maxWidth: 120 }}>
                                                                    <label className="text-muted fw-semibold">First Price:</label>
                                                                    <Form.Control
                                                                        size="sm"
                                                                        type="text"
                                                                        inputMode="decimal"
                                                                        pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                        className="border border-secondary rounded"
                                                                        placeholder="First Price"
                                                                        value={kindlePriceState}
                                                                        disabled={loading}
                                                                        onChange={(e) => setKindlePriceState(e.target.value)}
                                                                    />
                                                                </div>
                                                            )}

                                                            {newBook.paper_back_flag && (
                                                                <div className="d-flex flex-column mt-0" style={{ minWidth: 50, maxWidth: 120 }}>
                                                                    <label className="text-muted fw-semibold">Second Price:</label>
                                                                    <Form.Control
                                                                        size="sm"
                                                                        type="text"
                                                                        inputMode="decimal"
                                                                        pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                        className="border border-secondary rounded"
                                                                        placeholder="Second Price"
                                                                        value={paperbackPriceState}
                                                                        disabled={loading}
                                                                        onChange={(e) => setPaperbackPriceState(e.target.value)}
                                                                    />
                                                                </div>
                                                            )}

                                                            {newBook.hard_cover_flag && (
                                                                <div className="d-flex flex-column mt-0" style={{ minWidth: 50, maxWidth: 120 }}>
                                                                    <label className="text-muted fw-semibold">Third Price:</label>
                                                                    <Form.Control
                                                                        size="sm"
                                                                        type="text"
                                                                        inputMode="decimal"
                                                                        pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                        className="border border-secondary rounded"
                                                                        placeholder="Third Price"
                                                                        value={hardcoverPriceState}
                                                                        disabled={loading}
                                                                        onChange={(e) => setHardcoverPriceState(e.target.value)}
                                                                    />
                                                                </div>
                                                            )}
                                                            {newBook.audio_flag && (
                                                                <div className="d-flex flex-column mt-0" style={{ minWidth: 50, maxWidth: 120 }}>
                                                                    <label className="text-muted fw-semibold">Fourth Price:</label>
                                                                    <Form.Control
                                                                        size="sm"
                                                                        type="text"
                                                                        inputMode="decimal"
                                                                        pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                        placeholder="Fourth Price"
                                                                        className="border border-secondary rounded"
                                                                        value={fourthPriceState}
                                                                        disabled={loading}
                                                                        onChange={(e) => setFourthPriceState(e.target.value)}
                                                                    />
                                                                </div>
                                                            )}

                                                        </div>


                                                    </div>
                                                    <div className="text-muted" style={{ marginTop: 8, marginBottom: 0 }}>
                                                        <p style={{ marginBottom: 0 }}>
                                                            Pay close attention to the prices of your product variations and adjust them if necessary.
                                                        </p>
                                                    </div>


                                                </Form>
                                            </Card.Body>
                                        </Row>

                                    </Row>
                                </Card>
                            </Col>
                        </Row>

                        {/* COVER + UPLOAD PDF (адаптировано, все элементы с ) */}
                        <Row className="mb-0 p-2 flex-column flex-md-row small">
                            {/* COVER */}
                            <Col md={4} className="mt-0 p-2">
                                <Card className="mb-0 p-3 mt-0 border ">
                                    {coverPreview && (
                                        <div className="text-center mb-0 mt-0">
                                            <img
                                                src={coverPreview}
                                                alt="Cover Preview"
                                                className="img-fluid border-0 rounded"
                                                style={{ objectFit: "cover" }}
                                                width={300}
                                            />
                                        </div>
                                    )}
                                </Card>

                                <Row className="mb-3 m-lg-2 m-auto mt-3">
                                    <div className="d-flex justify-content-center mb-0 mt-1">
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-success me-2"
                                            onClick={triggerFileInput}   // существующий хэндлер
                                            disabled={loading}
                                        >
                                            Upload New Image
                                        </button>

                                        {/* скрытый input для выбора картинки обложки */}
                                        <input
                                            type="file"
                                            id="fileInput"
                                            style={{ display: "none" }}
                                            onChange={handleFileChange}  // существующий хэндлер
                                        />
                                    </div>
                                </Row>
                            </Col>

                            {/* UPLOAD PDF */}
                            <Col md={8} className="mt-0 p-2">




                                <Card className="mt-0">
                                    <Card.Body>
                                        <Row className="mb-0">
                                            <Col>
                                                <p className="text-start fw-semibold mb-0 text-muted">About this Product:</p>
                                                <Form.Control
                                                    className="p-2 border small rounded text-muted"
                                                    as="textarea"
                                                    rows={11}
                                                    value={summaryState}
                                                    onChange={e => setSummaryState(e.target.value)}
                                                    placeholder="Enter a short and meaningful summary for your book..."
                                                    style={{ fontSize: 14 }} // визуально приглушённый стиль
                                                />
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>

                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <Card className="mt-2 border border-secondary bg-secondary bg-opacity-10">
                                    <Card.Header className="py-1">
                                        <Form.Check
                                            type="checkbox"
                                            id="grab-product-public-catalog-visible"
                                            label={
                                                <span className="ms-1">
                                                    <span className="fw-semibold">I want to place my product in the public product store</span>
                                                    {publicCatalogVisible
                                                        ? " — members will be able to discover it in the public product store."
                                                        : " — your product will not be shown in the public product store."}
                                                </span>
                                            }
                                            checked={publicCatalogVisible}
                                            onChange={(e) => {
                                                const v = e.target.checked;
                                                setPublicCatalogVisible(v);
                                                saveBookDataToLocalStorage({ public_catalog_visible: v });
                                            }}
                                            className="custom-checkbox mt-2 me-2 mb-1"
                                        />
                                    </Card.Header>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <div className="d-flex justify-content-end mt-0">
                                <button
                                    type="button"
                                    className={`btn btn-sm justify-content-end ${isFormValid ? 'btn-success' : 'btn-light'}`}
                                    onClick={handleSubmitBookToModeration}
                                    disabled={!isFormValid || loading}
                                >
                                    {loading ? <Spinner as="span" animation="border" size="sm"/> : 'Submit for Moderation'}
                                </button>
                            </div>
                        </Row>


                    </Form>
                )}
                <CacheUpdateModalBook />
            </Card>
        </>
    );

});

export default AddProductByGrabFromAmazon;
